import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgVideoCamera = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M0.75 5.261H15.75V18.761H0.75V5.261Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.75 15.011L22.165 16.718C22.2793 16.7751 22.4064 16.802 22.534 16.7962C22.6617 16.7904 22.7858 16.7521 22.8945 16.6848C23.0032 16.6176 23.0929 16.5237 23.1551 16.4121C23.2173 16.3005 23.25 16.1748 23.25 16.047V7.974C23.2501 7.84618 23.2175 7.72046 23.1553 7.6088C23.093 7.49715 23.0033 7.40328 22.8945 7.33612C22.7858 7.26896 22.6616 7.23075 22.5339 7.22513C22.4062 7.21951 22.2792 7.24666 22.165 7.304L18.75 9.011"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgVideoCamera.displayName = 'SvgVideoCamera';
export default SvgVideoCamera;
